import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { TOGGLE_MODAL } from './constants';

const initialState = {
  modals: {},
  modalData: {},
};

export const modalReducer = createReducer(initialState, {
  [TOGGLE_MODAL]: (state, action) => {
    return {
      modals: {
        ...state.modals,
        [action.payload.key]: !!action.payload.isOpen,
        toolName: [action.payload.toolName],
      },
      modalData: {
        ...state.modalData,
        [action.payload.key]: action.payload.data || {},
      },
    };
  },
});
